// Real product screenshots and animations, shared by the landing and features pages.
// Files live in public/landing; screenshots come from the demo institute with phones and emails blurred.

export const SHOT = (file) => `/landing/${file}`;

// Browser window around a real screenshot. Full-page captures are 1600x1000, cropped ones 1344x840.
export const ScreenshotFrame = ({ file, alt, width = 1600, height = 1000, eager = false, className = '' }) => (
  <div className={`rounded-2xl bg-white border border-slate-200 shadow-2xl shadow-brand-ink/15 overflow-hidden ${className}`}>
    <div className="flex items-center gap-3 px-3 sm:px-4 py-2 bg-slate-50 border-b border-slate-200">
      <div className="flex gap-1.5" aria-hidden="true">
        <span className="w-2.5 h-2.5 rounded-full bg-[#FF5F57]" />
        <span className="w-2.5 h-2.5 rounded-full bg-[#FEBC2E]" />
        <span className="w-2.5 h-2.5 rounded-full bg-[#28C840]" />
      </div>
      <div className="flex-1 rounded-md bg-white border border-slate-200 px-3 py-0.5 text-[11px] sm:text-xs text-slate-500 truncate">mycoachhub.in</div>
    </div>
    <img
      src={SHOT(file)}
      alt={alt}
      width={width}
      height={height}
      loading={eager ? 'eager' : 'lazy'}
      fetchPriority={eager ? 'high' : undefined}
      decoding="async"
      className="block w-full h-auto"
    />
  </div>
);

// Phone frame around a real app screenshot (390x844 captured at 2x)
export const PhoneShot = ({ file, alt, eager = false, className = '' }) => (
  <div className={`rounded-[30px] bg-brand-night p-1.5 border border-brand-line shadow-2xl shadow-black/40 ${className}`}>
    <img
      src={SHOT(file)}
      alt={alt}
      width={780}
      height={1688}
      loading={eager ? 'eager' : 'lazy'}
      decoding="async"
      className="block w-full h-auto rounded-[24px]"
    />
  </div>
);

// Animated walkthrough (GIF) with a "live demo" label
export const AnimatedDemo = ({ file, alt, caption }) => (
  <figure className="rounded-[28px] bg-[#F6F3EC] border border-slate-200 shadow-2xl shadow-brand-ink/15 overflow-hidden">
    <img src={SHOT(file)} alt={alt} width={960} height={760} loading="lazy" decoding="async" className="block w-full h-auto" />
    <figcaption className="flex items-center gap-2 border-t border-slate-200 bg-white px-4 py-2.5 text-xs sm:text-sm font-semibold text-brand-ink">
      <span className="relative flex h-2.5 w-2.5" aria-hidden="true">
        <span className="absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75 animate-ping motion-reduce:animate-none" />
        <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-emerald-500" />
      </span>
      {caption}
    </figcaption>
  </figure>
);

// Showcase visual: an animation, or a screenshot with an optional second screen tucked in the corner
export const ShowcaseMedia = ({ gif, shot, inset }) => {
  if (gif) return <AnimatedDemo {...gif} />;
  return (
    <div className={`relative ${inset ? 'sm:pb-20 sm:pr-10' : ''}`}>
      <ScreenshotFrame {...shot} />
      {inset && (
        <ScreenshotFrame {...inset} className="hidden sm:block absolute right-0 bottom-0 w-[55%]" />
      )}
    </div>
  );
};
